var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"capital-market-publications-feedback"},[_c('VueFeedback',{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v("Hoppá")]),_c('template',{slot:"feedback-content"},[_vm._v("Technikai hiba történt!")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }